module.exports = __webpack_public_path__ + "img/huodong2.8836a3d.png";